import { collection, deleteDoc, doc, onSnapshot, setDoc } from 'firebase/firestore';
import { v4, v5 } from 'uuid';
import { StateCreator } from 'zustand';
import { firestore } from '../../settings/firebase';
import { EventInvite } from './store';
import dayjs from 'dayjs';

const COLLECTION_NAME = 'eventInvites';
const COLLECTION_ID = '2baa1e2e-c480-4b85-8b4a-27898a677028';

export interface EventInviteSlice {
  value: EventInvite[];
  hash: string;
  subscribe: () => {
    unSubscribe: () => void;
  };
  save: (
    item: Partial<EventInvite>,
    eventName: string
  ) => Promise<{ ok: boolean } | { error: string }>;
  delete: (name: string) => Promise<{ ok: boolean }>;
}

export const createEventInviteSlice: StateCreator<
  EventInviteSlice,
  [],
  [],
  EventInviteSlice
> = setState => ({
  value: [],
  hash: '',

  // Subscribe to changes in the distribution flow (this will update the UI in real time)
  subscribe: () => {
    const requestsRef = collection(firestore, COLLECTION_NAME);

    const unSubscribe = onSnapshot(requestsRef, snapshot => {
      // const value = getState().value;
      const value: EventInvite[] = [];
      snapshot.forEach(doc => {
        const data = doc.data() as EventInvite;
        value.push({ ...data, id: doc.id });
      });
      setState({ value, hash: v4() });
    });

    // To stop listening to changes when the component unmounts
    return {
      unSubscribe,
    };
  },
  // Subscribe to changes in the distribution flow (this will update the UI in real time)

  // Create a new distribution flow item or update an existing one
  save: async (data, eventName) => {
    try {
      const env = import.meta.env.VITE_ENV || 'development';
      const uid = v5(env + eventName + data.email, COLLECTION_ID);

      const itemRef = doc(firestore, COLLECTION_NAME, uid);
      // If it doesn't exist, create a new document
      await setDoc(
        itemRef,
        {
          ...data,
          uid,
          eventName,
          env,
          created: dayjs().format('YYYY-MM-DD HH:mm'),
        },
        { merge: false }
      );
    } catch (error: any) {
      return { error: 'There was an error submitting request: ' + error.code };
    }
    return { ok: true };
  },
  delete: async uid => {
    const itemRef = doc(firestore, COLLECTION_NAME, uid);
    await deleteDoc(itemRef);
    return { ok: true };
  },
});

export default createEventInviteSlice;
